import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/nintendo-switch': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M95.9 33.5c5.8-1 19.1-1.3 63.3-1.4 54.4-0.1 56 0 56.9 1.7 0.6 1.3 0.9 72.1 0.9 222.6 0 202.9-0.1 220.8-1.5 222.2-1.4 1.4-6.8 1.5-58.7 1.1-50.2-0.2-58-0.5-64.1-1.9-47-10.9-80-44-90.3-90.5-1.9-8.7-2-11.3-2.2-122.9-0.5-121.6-0.2-130.8 3.9-146.5 11.3-43.4 47.2-76.4 91.8-84.4zM179.8 256.1h-0.2v-188l-35.9 0.1c-39.7 0.1-45.4 0.7-57.6 5.6-24.3 9.7-42.4 31.3-48 57.4-1.9 9.2-1.9 239.9 0.1 249.3 6.3 30 28.4 53 58.3 60.7 7 1.7 10.7 1.9 45.5 2.3l37.8 0.5v-187.9zM103.9 124.9c23.3-4.7 46 11.3 49.9 35 3.5 20.1-8.7 39.6-28.8 46.4-4.9 1.7-7.5 2-14.8 1.7-8.1-0.3-9.7-0.6-15.9-3.7-9-4.4-15.5-11-19.9-20-3-5.9-3.4-7.9-3.8-15.2-0.8-14.1 4.1-26.1 13.8-34.5 4.8-4.1 13.7-8.6 19.5-9.7zM262.1 32.6c0.3-0.3 18.8-0.6 41.2-0.5 32.3 0 42.3 0.3 48.8 1.4 48.4 8.3 85.3 44.8 94.5 93.1 1.3 6.7 1.5 22.6 1.5 129 0 133.3 0.1 128.7-5.7 146.1-1.6 4.5-4.7 11.8-7 16.2-18 34-51.3 56.9-89 61.2-8.9 1-80.9 1.3-83.4 0.4-1.4-0.6-1.5-21.1-1.5-223.4 0-122.7 0.2-223.2 0.6-223.5zM361.2 234.7c-23.2-6.1-47.3 7.3-54.2 30-2.3 7.3-2.4 19.2-0.4 26.2 6.7 23 31.4 37 54.6 31 14.3-3.8 25.4-14.1 31.1-28.8 3.1-8 3.2-20.8 0.1-29.5-4.9-14.1-16.7-25.1-31.2-28.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/nintendo-switch.js
// module id = null
// module chunks = 